/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Lastchange1Inputs */

const he_item_stats_lastchange1 = /** @type {(inputs: Item_Stats_Lastchange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שינוי מחיר אחרון`)
};

const en_item_stats_lastchange1 = /** @type {(inputs: Item_Stats_Lastchange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last change`)
};

/**
* | output |
* | --- |
* | "Last change" |
*
* @param {Item_Stats_Lastchange1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_lastchange1 = /** @type {((inputs?: Item_Stats_Lastchange1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Lastchange1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_lastchange1(inputs)
	return en_item_stats_lastchange1(inputs)
});
export { item_stats_lastchange1 as "item_stats_lastChange" }